export class PACoordinates {

  constructor(
    public latitude: number,
    public longitude: number,
    public name?: string,
    public zip_code?: string
  ) {
  }

  equalCoordinates(coordinates: PACoordinates): boolean {
    return this.latitude == coordinates.latitude && this.longitude == coordinates.longitude
  }
}
